import React, { Component, useState } from "react";
import Sidebar from "../components/Sidebar";
import UserSearch from "../components/UserSearch";
import InventorySearch from "../components/InventorySearch";
import LocationSearch from "../components/LocationSearch";
import PresetVoucher from "../components/PresetVoucher";
import StocktakeSearch from "../components/StocktakeSearch";
import DepartmentSearch from "../components/DepartmentSearch";
import RoleSearch from "../components/RoleSearch";
import Merchandise from "../components/Merchandise";
import "../styles.css";
import "../components/InventorySearch.css";

function AdminDashboard() {
  const [view, setView] = useState("inventory");

  const renderContent = () => {
    switch (view) {
      case "users":
        return <UserSearch />;
      case "inventory":
        return <InventorySearch />;
      case "Locations":
        return <LocationSearch />;
      case "merchandise":
        return <Merchandise />;
      case "Department":
        return <DepartmentSearch />;        
      case "Stocktake":
        return <StocktakeSearch />;
      case "AccessRole":
        return <RoleSearch />;
    }
  };

  return (
    <div className="admin-dashboard">
      <Sidebar onSelect={setView} />
      <div className="dashboard-content">{renderContent()}</div>
    </div>
  );
}

export default AdminDashboard;
